import { render, staticRenderFns } from "./option-buttons.vue?vue&type=template&id=c905c932&lang=pug&"
import script from "./option-buttons.vue?vue&type=script&lang=js&"
export * from "./option-buttons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports